import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectStats } from 'shared/selectors';

export const useTitle = () => {
  const offerStats = useSelector(selectStats);

  return React.useMemo(() => {
    const { totalUniqueViewsFormattedString, totalViewsFormattedString } = offerStats || {};

    if (totalViewsFormattedString) {
      const uniqueViewsPart = totalUniqueViewsFormattedString ? `, ${totalUniqueViewsFormattedString}` : '';

      return `${totalViewsFormattedString}${uniqueViewsPart}`;
    } else {
      // На самом деле totalViewsFormattedString всегда есть, удалить после обновления контракта в CD-253420
      return '0 просмотров, 0 за сегодня';
    }
  }, [offerStats]);
};
